
import template from 'header/site-message.j2';
import { closeSiteMessage } from '../actions/siteMessageActions';
import { generate } from '../../../core/js/utils/componentUtils';

let config = {
    templateLocation: '.dom-site-message',
    watch: 'core.siteMessage',
    name: 'siteMessageComponent',
    onStateChange: onStateChange,
    template: template,
    attachEvents: attachEvents
};

export function init(store, overrides = {}) {
    return generate(config, store, overrides);
}

export function onStateChange(store) {
    this.render(store, this, {});
}

export function attachEvents(store) {
    $(document).on('click', '.js-site-message__close-link', (e) => {
        e.preventDefault();
        store.dispatch(closeSiteMessage());
    });
}
